import { ForgotPasswordForm } from "@/components/common/ForgotPasswordForm";

export default function RequestReset() {
  return (
    <div className="w-full h-screen flex">
      <div className="w-full flex justify-center h-full">
        <div className="w-1/2 content-center max-w-[400px]">
          <ForgotPasswordForm />
        </div>
      </div>
    </div>
  );
}
